<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchCardShow"
                :gutter="16">
                <Col span="24">
                <search-card :form="mainTable.searchForm"
                    :table-load-event="getActionTableRecords"
                    :table-search="mainTable.tableSearch" />
                </Col>
            </Row>
        </transition>

        <Card>
            <Row :gutter="16">
                <Col span="24">
                <div class="global-tool-bar">
                    <div class="left-bar">
                        <span class="title">日志管理</span>
                    </div>
                    <div class="right-bar">
                        <Button type="primary"
                            size="small"
                            class="btns"
                            shape="circle"
                            icon="ios-search"
                            @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                    </div>
                </div>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <stand-pagination-table :columns="mainTable.columns"
                    :data="mainTable.data"
                    :loading="mainTable.loading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getActionTableRecords" />
                </Col>
            </Row>
        </Card>
    </div>

</template>

<script>
import search from '@/libs/search';
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getActionList } from '@/api/modules/system-management/action-management';

export default {
    name: 'ActionList',
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            mainTable: {
                columns: [
                    { title: '操作账号', key: 'actionUserName', align: 'center' },
                    { title: '操作人员', key: 'actionUserPersonName', align: 'center' },
                    { title: '操作项', key: 'actionFunctionName', align: 'center' },
                    { title: '描述', key: 'actionRemark', align: 'center' },
                    { title: 'IP地址', key: 'actionIp', align: 'center' },
                    { title: '操作时间', key: 'actionCreatedAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.actionCreatedAt) }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '操作人员', type: 'Input', value: '', name: 'concat(actionUserName,actionUserPersonName)', sql: 'like' },
                    { label: '操作时间', type: 'Daterange', value: '', name: 'actionCreatedAt', sql: 'dateBetween' }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getActionTableRecords();
    },
    methods: {
        getActionTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getActionList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.loading = false;
            }).catch(() => {
                this.mainTable.loading = false;
            });
        }
    }
};
</script>

<style lang="less" scoped>
</style>
